import React, { useState, useEffect } from 'react';
import { Button, Card, message, Table } from 'antd';
import { EyeOutlined, UploadOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import axios from '../util/axiosConfig'
import '../styles/userlist.css'
import { usePagination } from '../context/PaginationProvider';

const AddressList: React.FC = () => {
    const { pagination, setTotal, setPage, setPageSize } = usePagination();
    const { page, pageSize, sort_by, sort_order } = pagination;
    const [roles, setRoles] = useState<any>([]);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [, setPaginationConfig] = useState({
        current: page,
        pageSize: pageSize,
        total: 0,
        showTotal: (total: number, range: [number, number]) => `Showing ${range[0]}-${range[1]} of ${total} entries`,
        showSizeChanger: true,
        pageSizeOptions: ["5", "10", "20", "50"],
        locale: { items_per_page: "" },
        onChange: (page: number, pageSize: number) => {
            setPage(page);
            setPageSize(pageSize);
            setPaginationConfig((prev: any) => ({
                ...prev,
                current: page,
                pageSize: pageSize,
            }));
        },
        onShowSizeChange: (current: number, size: number) => {
            setPage(current);
            setPageSize(size);
            setPaginationConfig((prev: any) => ({
                ...prev,
                current: current,
                pageSize: size,
            }));
        },
    });

    const fetchRoleList = async () => {
        setLoading(true);
        try {
            const response = await axios.get('/agreement/get-agreement-list');
            //     const response = await axios.post('/roles/pageable-roles', {}, {
            //     params: {
            //         pageSize: pageSize,
            //         pageNo: page - 1,
            //         sortByField: sort_by,
            //         sortDirection: 'desc',
            //     },
            // });
            const content = response?.data?.data || [];

            if (Array.isArray(content)) {
                setRoles(content);
                setTotal(response.data?.data?.totalElements || 0);
                setPaginationConfig((prev) => ({
                    ...prev,
                    total: response.data?.data?.totalElements || 0,
                }));
            } else {
                console.error('Unexpected response format:', response.data);
            }
        } catch (error) {
            console.error('Failed to fetch panel data', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchRoleList();
        // eslint-disable-next-line
    }, [page, pageSize, sort_by, sort_order]);

    const showPDFModel = (e: React.MouseEvent, record:any) => {
        e.stopPropagation();
        const url = record?.fileUrl;
        window.open(url, '_blank');
    };

    const exportData = async () => {
        try {
            setLoading(true);

            const response = await axios.post('/agreement/export-agreements',{},
                {
                    responseType: 'blob',
                }
            );

            // Generate current date and time in Indian format (DD-MM-YYYY_HH-MM-SS)
            const now = new Date();
            const indianTime = new Date(now.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
            const day = indianTime.getDate().toString().padStart(2, '0');
            const month = (indianTime.getMonth() + 1).toString().padStart(2, '0');
            const year = indianTime.getFullYear();
            const hours = indianTime.getHours().toString().padStart(2, '0');
            const minutes = indianTime.getMinutes().toString().padStart(2, '0');
            const seconds = indianTime.getSeconds().toString().padStart(2, '0');
            const formattedDate = `${day}-${month}-${year}_${hours}-${minutes}-${seconds}`;

            const fileName = `Belong_In_Favour_of_List_${formattedDate}.xlsx`;

            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
            message.success('Export successful!');
        } catch (error) {
            console.error('Export failed:', error);
            message.error('Export failed. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const columns: any = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            width: '15%'
        },
        {
            title: 'BELONG - In Favour of',
            dataIndex: 'address',
            key: 'address',
            width: '30%'
        },
        {
            title: 'Location',
            dataIndex: 'location',
            key: 'location',
            width: '10%'
        },
        {
            title: 'District',
            dataIndex: 'district',
            key: 'district',
            width: '10%'
        },
        {
            title: 'Pincode',
            dataIndex: 'pincode',
            key: 'pincode',
            width: '10%'
        },
        {
            title: 'Details',
            dataIndex: 'details',
            key: 'details',
            width: '20%'
        },
        {
            title: 'Action',
            key: 'action',
            width: '5%',
            align: 'center',
            render: (text: any, record: any) => (
                <>
                    <EyeOutlined style={{ cursor: 'pointer' }} title={'Preview Document'} onClick={(e) => showPDFModel(e,record)} />
                </>
            ),
        },
    ];

    return (
        <>
            <Card
                title="Address List"
                bordered={false}
                extra={
                    <Button type="default" style={{ marginRight: '8px' }} onClick={exportData}>
                        Export
                    </Button>
                }
            >
                <Table
                    loading={loading}
                    className='roleTable'
                    dataSource={roles}
                    columns={columns}
                    bordered={false}
                    size='small'
                    pagination={false}
                />
            </Card>
            <Button
                type="primary"
                shape="circle"
                icon={<UploadOutlined />}
                hidden={false}
                style={{
                  position: 'fixed',
                  bottom: '24px',
                  right: '24px',
                  display: 'block'
                }}
                onClick={() => navigate('/upload', {
                  state: { fromPage: 'address-list' }
                })}
            />
        </>
    );
};

export default AddressList;
